import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Form,
  Container,
  Row,
  Image,
  Modal,
  Button,
} from "react-bootstrap";
import Media from "react-media";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import {
  UPDATE_PAYMENT_METHOD,
  UPDATE_PAYMENT_WALLET_DETAILS,
} from "../../../../src/store/types";
import moment from "moment";
import RightComponentOrderRequest from "./OrderRequest/RightComponentOrderRequest";
import { CREATE_ORDER_VENDOR } from "../../../../src/store/types";
import { getFlatCharges } from "../../../function/getFlatCharges";
import Alert from "react-s-alert";
import CashModal from "../../reusableComponents/CashModalComponent";
import { ORDER_TYPE_NAME } from "../../../enums/OrderEnums";
import { getPendingPayment } from "../../../function/getPendingPayment";
import { calcFinalTotal } from "../../../function/ordering";
import ReRightComponentOrderRequest from "./ReRightComponentOrderRequest";

const OrderPaymentMain = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [emailCheck, setEmailCheck] = useState(false);
  const [selectedValue, setSelectedValue] = useState(6);
  const [externalWalletId, setexternalWalletId] = useState("");
  const [showCashModal, setShowCashModal] = useState(false);
  const payNow = history?.location?.state?.type === "PAY_NOW" ? true : false;
  // const onChangeWalletId = (e) => {
  //   setexternalWalletId(e.target.value);
  // };

  // const onClickWalletSubmit = () => {
  //   dispatch({
  //     type: UPDATE_PAYMENT_WALLET_DETAILS,
  //     payload: externalWalletId,
  //   });
  //   Alert.success(`<h4>Wallet Details Submited Successfully</h4>`, {
  //     position: "top-right",
  //     effect: "bouncyflip",
  //     beep: true,
  //     html: true,
  //     timeout: 3000,
  //     offset: 35,
  //   });
  // };

  const onClickRemoveWalletDetails = () => {
    setexternalWalletId("");
    dispatch({
      type: UPDATE_PAYMENT_WALLET_DETAILS,
      payload: "",
    });
    Alert.success(`<h4>Wallet Details Removed Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const payment_method = useSelector(
    (state) => state.vendorOrdering.vendor_order_data
  );

  const onChangePaymentType = (id) => {
    if (id === 8) {
      setShowCancel(true);
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    } else if (id === 9) {
      setShowCashModal(true);
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    } else {
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    }
  };

  const onEmailCheckAction = () => {
    setEmailCheck(!emailCheck);
    let user_Data = props.user_data;
    user_Data.get_receipt_email = emailCheck ? false : true;
    dispatch({ type: CREATE_ORDER_VENDOR, payload: user_Data });
  };

  // if (props.user_data.isOfferApplied) {
  //   if (props.user_data.isPercentage === false) {
  //     if (props.user_data.discountAmount === price) {
  //       return 0;
  //     }
  //   }
  //   //  else {
  //   //   return charges.toFixed(2);
  //   // }
  // } else {
  //   return charges.toFixed(2);
  // }

  // const calcFinalTotal = (data) => {
  //   let base_amount = calcTotal(data);
  //   let taxes = calcCharges(data);
  //   let surCharges = calcSurCharges(data);
  //   let finalTotal =
  //     parseFloat(base_amount) + parseFloat(taxes) + parseFloat(surCharges);

  //   if (props?.user_data?.tip?.amount) {
  //     finalTotal = finalTotal + props.user_data.tip.amount;
  //   }
  //   if (props?.user_data?.donation?.amount) {
  //     finalTotal = finalTotal + props.user_data.donation.amount;
  //   }
  //   return finalTotal?.toFixed(2) || 0;
  // };

  const calcPrepTIme = () => {
    let bufferTime = props.onboarding.orderBufferTime;
    let all_time_arr = [];

    for (let i = 0; i < props.cart_data.length; i++) {
      if (
        props.cart_data[i][0] &&
        props.cart_data[i][0].item &&
        props.cart_data[i][0].item.prepTime
      )
        all_time_arr.push(props.cart_data[i][0].item.prepTime);
    }
    let max_time = Math.max(...all_time_arr);
    if (bufferTime !== "" && bufferTime !== undefined) {
      max_time = max_time + parseInt(bufferTime && bufferTime.split("-")[1]);
    }
    return max_time;
  };

  const [showCancel, setShowCancel] = useState(false);

  const submitExternal = (data) => {
    dispatch({
      type: UPDATE_PAYMENT_WALLET_DETAILS,
      payload: data,
    });
    dispatch({ type: UPDATE_PAYMENT_METHOD, payload: 8 });
    setShowCancel(false);
  };

  useEffect(() => {
    setSelectedValue(payment_method.payment_method);
  }, [payment_method]);

  const [orderData, setOrderData] = useState({ items: 0, total: 0 });

  useEffect(() => {
    let data = { items: 0, total: 0 };
    if (payNow) {
      data.total = getPendingPayment(props?.user_data);
      data.items = props?.user_data?.order_items?.length;
    } else {
      let cal = calcFinalTotal(
        props?.cart_data,
        props?.user_data,
        props?.offerData,
        props.subscription
      );
      data.total = cal.total;
      data.items = props?.cart_data?.length;
    }
    setOrderData(data);
  }, [props.user_data, props.cart_data]);

  try {
    return (
      <React.Fragment>
        <MuiThemeProvider theme={theme}>
          <Container fluid style={{ marginBottom: "50px" }}>
            <h3>Payment </h3>
            <div style={{ paddingTop: "2%" }}>
              <Row>
                <Col xs={6}>
                  <TextField
                    disabled
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    className="w-100"
                    value={
                      props &&
                      props.user_data &&
                      props.user_data.user_details &&
                      props.user_data.user_details.first_name
                    }
                  />
                </Col>
                <Col xs={6}>
                  <TextField
                    disabled
                    id="outlined-basic"
                    label="Last Name"
                    variant="outlined"
                    className="w-100"
                    value={
                      props &&
                      props.user_data &&
                      props.user_data.user_details &&
                      props.user_data.user_details.last_name
                    }
                  />
                </Col>
              </Row>
              <br />
              <div className="row">
                <div className="col-md-6 col-12">
                  <PhoneComponent
                    mobile_number={
                      props &&
                      props.user_data &&
                      props.user_data.user_details &&
                      props.user_data.user_details.mobile_number
                    }
                    country_code={
                      props &&
                      props.user_data &&
                      props.user_data.user_details &&
                      props.user_data.user_details.country_code
                    }
                  />
                </div>
                {/* <div className="col-6">
                {emailCheck ? (
                  <Col xs={12} className="p-0">
                    <TextField
                      disabled
                      id="outlined-basic"
                      label="Email"
                      variant="outlined"
                      className="w-100"
                      value={
                        props &&
                        props.user_data &&
                        props.user_data.user_details &&
                        props.user_data.user_details.email
                      }
                    />
                  </Col>
                ) : (
                  <></>
                )}
              </div> */}
              </div>
              <Row style={{ paddingLeft: "15px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={emailCheck}
                      color="primary"
                      onChange={() => onEmailCheckAction()}
                      name="checkedA"
                    />
                  }
                  label="Would you like to get receipt in email?"
                />
              </Row>
              <hr />
              <Row>
                <Col>
                  <h5 className="f18-700 mb-4">Order Details</h5>
                  <p className="f14-500 mb-4">
                    Order ID:
                    <span className="ml-2" style={{ color: "#F85032" }}>
                      {props.user_data &&
                      props.user_data?.order_id !== null &&
                      props.user_data &&
                      props.user_data?.order_id !== undefined &&
                      props.user_data &&
                      props.user_data?.order_id !== ""
                        ? props.user_data && props.user_data?.order_id
                        : "N/A"}
                    </span>
                  </p>
                  <p className="f14-500 mb-4">
                    Order Type:
                    <span className="badge badge-warning px-3 py-1 ml-2 f9-500">
                      {" "}
                      {
                        ORDER_TYPE_NAME[
                          props.user_data && props.user_data.order_type
                        ]
                      }
                    </span>
                  </p>
                </Col>
              </Row>
              <Container fluid>
                <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
                  <Col md={3}>
                    <b>
                      {props?.user_data?.order_type === 0 ||
                      props?.user_data?.order_type === 1 ||
                      props?.user_data?.now === true
                        ? moment(props?.user_data.nowDate).format(
                            "Do MMMM YYYY"
                          )
                        : moment(props?.user_data?.later_date).format(
                            "Do MMMM YYYY"
                          )}
                    </b>
                    <br />
                    <span style={{ color: "#757575" }}>Date</span>
                  </Col>
                  <Col md={2}>
                    <b>
                      {props?.user_data?.order_type === 0 ||
                      props?.user_data?.order_type === 1 ||
                      props?.user_data?.now === true
                        ? moment(props?.user_data.nowDate).format("hh : mm A")
                        : moment(props?.user_data?.later_date).format("LT")}
                    </b>
                    <br />
                    <span style={{ color: "#757575" }}>Time</span>
                  </Col>
                  <Col md={4}>
                    <b>
                      {calcPrepTIme() === -Infinity
                        ? props?.user_data?.max_time
                        : calcPrepTIme()}{" "}
                      Mins Preparation{" "}
                    </b>
                    <br />
                    <span style={{ color: "#757575" }}>Time</span>
                  </Col>
                  <Col md={3}>
                    <b>{orderData.items} Items </b>
                    <br />
                    <span style={{ color: "#757575" }}>Quantity</span>
                  </Col>
                </Row>
                <br />
                {props.cart_data.length > 0 || payNow ? (
                  <Row
                    style={{
                      backgroundColor: "#FFFBEE",
                      padding: "15px",
                      display: "flex",
                    }}
                    className="align-items-center"
                  >
                    <p
                      className="mr-3"
                      style={{ fontWeight: "bold", fontSize: "1.5rem" }}
                    >
                      ₹ {orderData.total}
                    </p>
                    <p style={{ color: "#212121" }}>Total Amount To Be Paid</p>
                  </Row>
                ) : (
                  <Fragment></Fragment>
                )}
                <hr />
                <div className="f20-700">Select payment method</div>
                <br />
                {paymentData.map((data, index) => {
                  if (
                    props?.location?.pathname
                      ?.toString()
                      ?.includes("reorderpayment")
                  ) {
                    if (data?.id === 6) return null;
                  }
                  return (
                    <Fragment key={index}>
                      {data.show ? (
                        <PaymentsInfo
                          data={data}
                          walletData={payment_method}
                          selectedValue={selectedValue}
                          extWalletId={externalWalletId}
                          // onwalletIdChange={onChangeWalletId}
                          // onSubmitWallet={() => onClickWalletSubmit()}
                          onRemoveWallet={() => onClickRemoveWalletDetails()}
                          handlePaymentType={() => onChangePaymentType(data.id)}
                        />
                      ) : (
                        <Fragment></Fragment>
                      )}
                    </Fragment>
                  );
                })}
                {showCancel && (
                  <ExternalReference
                    hideCancel={() => setShowCancel(false)}
                    submitExternal={submitExternal}
                  />
                )}
                {showCashModal && (
                  <CashModal
                    hideModal={() => setShowCashModal(false)}
                    total={orderData?.total}
                    cartData={props?.cart_data}
                    userData={props?.user_data}
                    offerData={props?.offerData}
                    subscriptionData={props?.subscription}
                    payNow={payNow}
                  />
                )}
              </Container>
            </div>
            <Media query="(max-width: 991px)">
              {payNow ? (
                <ReRightComponentOrderRequest
                  payment={true}
                  onlyPayment={true}
                  selectedValueId={selectedValue}
                />
              ) : (
                <RightComponentOrderRequest payment={true} onlyPayment={true} />
              )}
            </Media>
          </Container>
        </MuiThemeProvider>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
  cart_data: state.vendorOrdering.vendor_cart_data,
  user_data: state.vendorOrdering.vendor_order_data,
  offerData: state.offersevents.vendor_all_offers,
});

export default withRouter(connect(mapStateToProps, null)(OrderPaymentMain));

const theme = createTheme({
  palette: {
    primary: { main: "#EE3A23" }, // Purple and green play nicely together.
    secondary: { main: "#9E9E9E" }, // This is just green.A700 as hex.
  },
});

const PaymentsInfo = (props) => {
  const [data, setData] = React.useState(props.data);
  const [view, setView] = React.useState(false);
  try {
    return (
      <div>
        <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
          <Col md={1} xs={1}>
            <Radio
              checked={data.id === props.selectedValue ? true : false}
              onChange={(e) => {
                setView(true);
                props.handlePaymentType(e.target.value);
              }}
              value={data.value}
              name="radio-button-demo"
              color="primary"
              inputProps={{ "aria-label": data.value }}
            />
          </Col>
          <Col md={1} xs={1}>
            <img src={data.icon} />
          </Col>
          <Col md={8} xs={6}>
            <b>{data.title}</b>
          </Col>
          <Col md={2} xs={2} align="right">
            <Image src={require("../../../assets/images/Menu/Arrow.svg")} />
          </Col>
        </Row>
        {/* {data.value === "PayTM" && props.selectedValue === "PayTM" && (
        <Container style={{ padding: "20px" }}>
          <h5>Send a Request to</h5>
          <br />
          <b>Enter Mobile Number</b>
          <br />
          <PhoneComponent />
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
            >
              Send Link
            </button>
          </div>
          <br />
          <br />
        </Container>
      )} */}
        {data.value === "Wallet" && props.selectedValue === 7 && (
          <Row className="bg-white">
            <div className="col-5 offset-1 pl-4">
              <Form.Group>
                <TextField
                  id="outlined-basic"
                  label="Enter External Wallet Details"
                  variant="outlined"
                  className="w-100"
                  value={props.extWalletId}
                  // onChange={(e) => props.onwalletIdChange(e)}
                />
                <button
                  type="button"
                  className="btn f12-500 px-2 py-2 border mt-3 w-25 text-white"
                  style={{ backgroundColor: "#EE3A23" }}
                  title={
                    props.walletData?.walletDetails === "" ||
                    props.walletData?.walletDetails === undefined ||
                    props.walletData?.walletDetails === null
                      ? "Save"
                      : "Remove"
                  }
                  onClick={
                    props.walletData?.walletDetails === "" ||
                    props.walletData?.walletDetails === undefined ||
                    props.walletData?.walletDetails === null
                      ? props.onSubmitWallet
                      : props.onRemoveWallet
                  }
                >
                  {props.walletData?.walletDetails === "" ||
                  props.walletData?.walletDetails === undefined ||
                  props.walletData?.walletDetails === null
                    ? "Save"
                    : "Remove"}
                </button>
              </Form.Group>
            </div>
          </Row>
        )}
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};

export const PhoneComponent = (props) => {
  try {
    return (
      <Row>
        <Col xs={12} md={12}>
          <Row>
            <Col xs={3} className="pr-0">
              <Form.Group controlId={"country_code"}>
                <FormControl variant="outlined" className="w-100">
                  <Select
                    disabled
                    value={+91}
                    // onChange={handleChangeCode}
                    inputProps={{
                      name: "code",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value={+91}>{props.country_code}</option>
                  </Select>
                </FormControl>
              </Form.Group>
            </Col>
            <Col xs={9}>
              <Form.Group>
                <TextField
                  disabled
                  id="outlined-basic"
                  label="Phone Number"
                  variant="outlined"
                  className="w-100"
                  value={props.mobile_number}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  } catch (e) {
    console.log(e);
  }
};

const paymentData = [
  {
    id: 6,
    title: "Pay later",
    value: "Pay later",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 9,
    title: "Cash",
    value: "Cash",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 8,
    title: "External Wallet",
    value: "Wallet",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 1,
    title: "BHIM UPI",
    value: "BHIM UPI",
    icon: require("../../../assets/images/Orders/sdmlM4R-_400x400.png"),
    show: false,
  },
  {
    id: 2,
    title: "PayTM",
    value: "PayTM",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: false,
  },
  {
    id: 3,
    title: "Debit Card",
    value: "Debit Card",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 4,
    title: "Credit Card",
    value: "Credit Card",
    icon: require("../../../assets/images/superadmin/ordericon/phone-credit card-money-finance.svg"),
    show: true,
  },
  {
    id: 5,
    title: "Net Banking",
    value: "Net Banking",
    icon: require("../../../assets/images/superadmin/ordericon/online-payment.svg"),
    show: false,
  },
];

const ExternalReference = (props) => {
  const [ref, setRef] = useState("");
  const [refErr, setRefErr] = useState(false);

  const handleDesc = (e) => {
    if (!e.target.value) {
      setRefErr(true);
    } else {
      setRefErr(false);
      setRef(e.target.value);
    }
  };

  const submitCancel = () => {
    if (ref) {
      props.submitExternal(ref);
    } else {
      setRefErr(true);
    }
  };

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">Enter Transaction Reference</div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            <Form.Group>
              <TextField
                id="reference"
                variant="outlined"
                label="Reference"
                name="reference"
                className={`w-100  ${refErr ? "enError" : ""}`}
                onChange={handleDesc}
                helperText={refErr ? "Enter Transaction Reference" : ""}
                value={ref}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={submitCancel}
                >
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
